import React, { Component } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CheckIcon from '@mui/icons-material/Check';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FlagIcon from '@mui/icons-material/Flag'
import { observer } from 'mobx-react';
import MainStore from '../../../MainStore';
import NatureIcon from '@mui/icons-material/Nature';
import BlenderIcon from '@mui/icons-material/Blender';
import classNames from 'classnames';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import SearchIcon from '@mui/icons-material/Search';
import DoneIcon from '@mui/icons-material/DoneOutline';
import MoneyIcon from '@mui/icons-material/AttachMoney';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import MoodIcon from '@mui/icons-material/Mood';
import MoodBadIcon from '@mui/icons-material/MoodBad';
import MenuIcon from '@mui/icons-material/Menu';
import WorkStore from '../Kanban/WorkStore';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { ProjectDistributionReport } from '../Reports/ProjectDistributionReport';
import { AllProjectsCosts } from '../Reports/AllProjectsCosts';
import { WorkPressureReport } from '../Reports/WorkPressureReport';
import { EffectivityReport } from '../Reports/EffectivityReport';

const FilterBottomPanel = observer(class FilterBottomPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchStr: '',
            searchPlaceHolder: 'Заголовок',
            selectedReport: 0
        };

        this.handleCardAdd = this.handleCardAdd.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleCardAdd() {
        WorkStore.openWorkDialog({ caption: this.state.searchStr, sessionId: this.uuidv4(), description: '', sp: -1 });
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    handleSearchStrChange(evt) {

    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    render() {
        return (
            <Collapse in={this.state.isOpen} collapsedSize="30px" className="filter-bottom-panel-wrapper">
                <div className="filter-bottom-panel">
                    <IconButton
                        className="filter-expand-icon"
                        onClick={() => this.setState({ isOpen: !this.state.isOpen })}
                        size="large">
                        {!this.state.isOpen && <ExpandLessIcon />}
                        {this.state.isOpen && <ExpandMoreIcon />}
                    </IconButton>

                    <div className="add-button-block">
                        <IconButton
                            className="filter-add-button-icon"
                            onClick={this.handleCardAdd}
                            size="large"><AddIcon style={{ fill: "red" }} /></IconButton>
                    </div>

                    <div className="search-button-block">

                        <FormControl>
                            <IconButton
                                className="search-button-menu-icon"
                                aria-label="menu"
                                onClick={(evt) => this.setState({ "anchorEl": evt.currentTarget })}
                                size="large">
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="simple-menu"
                                anchorEl={this.state.anchorEl}
                                keepMounted
                                open={Boolean(this.state.anchorEl)}
                                onClose={this.handleClose}
                            >
                                <MenuItem value="0" onClick={() => { this.setState({ "anchorEl": null, "searchType": 0, "searchPlaceHolder": "Заголовок" }); this.props.handleChange('searchType')({ "target": { "value": 0 } }) }}>Заголовок</MenuItem>
                                <MenuItem value="1" onClick={() => { this.setState({ "anchorEl": null, "searchType": 1, "searchPlaceHolder": "Заголовок+Описание" }); this.props.handleChange('searchType')({ "target": { "value": 1 } }) }}>Заголовок+Описание</MenuItem>
                                <MenuItem value="2" onClick={() => { this.setState({ "anchorEl": null, "searchType": 2, "searchPlaceHolder": "Везде" }); this.props.handleChange('searchType')({ "target": { "value": 2 } }) }}>Везде</MenuItem>
                            </Menu>
                            <Input
                                id="adornment-search"
                                className="search-filter-input"
                                type='text'
                                value={this.state.searchStr}
                                placeholder={this.state.searchPlaceHolder}
                                onChange={(evt) => { this.props.handleChange('searchStr')(evt); this.handleChange('searchStr')(evt); }}
                                onKeyPress={(event) => (event.key === 'Enter') && this.props.startSearch()}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="начать поиск"
                                            onClick={() => { this.props.startSearch(null); }}
                                            size="large">
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </div>

                    <div className={classNames({ "filter-small-bottom-item": true, "active": MainStore.getIsFilterByFlagged })} onClick={() => { MainStore.setFilterByFlagged(!MainStore.getIsFilterByFlagged); if (this.props.filterChanged) this.props.filterChanged(); }}>
                        <Tooltip title="Зафлаженные задачи">
                            <IconButton size="small">
                                <FlagIcon />
                            </IconButton>
                        </Tooltip>
                    </div>

                    <div className={classNames({ "filter-small-bottom-item": true, "active": MainStore.getIsFilterByEmptySP })} onClick={() => { MainStore.setFilterByEmptySP(!MainStore.getIsFilterByEmptySP); if (this.props.filterChanged) this.props.filterChanged(); }}>
                        <Tooltip title="Неоцененные задачи">
                            <IconButton size="medium">
                                <div className="text-icon">-1</div>
                            </IconButton>
                        </Tooltip>
                    </div>

                    <div className={classNames({ "filter-small-bottom-item": true, "active": MainStore.getIsFilterByGeneralWork })} onClick={() => { MainStore.setFilterByGeneralWork(!MainStore.getIsFilterByGeneralWork); if (this.props.filterChanged) this.props.filterChanged(); }}>
                        <Tooltip title="Задачи без ответственных">
                            <IconButton size="medium">
                                <NatureIcon />
                            </IconButton>
                        </Tooltip>
                    </div>

                    <div className={classNames({ "filter-small-bottom-item": true, "active": MainStore.getIsFilterByProgrammersWork })} onClick={() => { MainStore.setIsFilterByProgrammersWork(!MainStore.getIsFilterByProgrammersWork); if (this.props.filterChanged) this.props.filterChanged(); }}>
                        <Tooltip title="Задачи разработчиков">
                            <IconButton size="medium">
                                <MoodIcon />
                            </IconButton>
                        </Tooltip>
                    </div>

                    <div className={classNames({ "filter-small-bottom-item": true, "active": MainStore.getIsFilterByAnalystWork })} onClick={() => { MainStore.setIsFilterByAnalystWork(!MainStore.getIsFilterByAnalystWork); if (this.props.filterChanged) this.props.filterChanged(); }}>
                        <Tooltip title="Задачи аналитиков">
                            <IconButton size="medium">
                                <MoodBadIcon />
                            </IconButton>
                        </Tooltip>
                    </div>

                    <div className={classNames({ "filter-small-bottom-item": true, "active": MainStore.getIsFilterByNotEmptySale })} onClick={() => { MainStore.setIsFilterByNotEmptySale(true); if (this.props.filterChanged) this.props.filterChanged(); }}>
                        <Tooltip title="Только продажи">
                            <IconButton size="medium">
                                <MoneyIcon />
                            </IconButton>
                        </Tooltip>
                    </div>

                    <div className={classNames({ "filter-small-bottom-item": true, "active": !MainStore.getIsFilterByNotEmptySale })} onClick={() => { MainStore.setIsFilterByNotEmptySale(false); if (this.props.filterChanged) this.props.filterChanged(); }}>
                        <Tooltip title="Без продаж">
                            <IconButton size="medium">
                                <MoneyOffIcon />
                            </IconButton>
                        </Tooltip>
                    </div>

                    <div className={classNames({ "filter-small-bottom-item": true, "active": MainStore.getIsFilterByProduct })} onClick={() => { MainStore.setIsFilterByProduct(true); if (this.props.filterChanged) this.props.filterChanged(); }}>
                        <Tooltip title="Только продукты">
                            <IconButton size="medium">
                                <BlenderIcon />
                            </IconButton>
                        </Tooltip>
                    </div>

                    <div className={classNames({ "filter-small-bottom-item": true, "active": MainStore.getIsFilterByOnlyApproved })} onClick={() => { MainStore.setIsFilterByOnlyApproved(true); if (this.props.filterChanged) this.props.filterChanged(); }}>
                        <Tooltip title="Только согласованные">
                            <IconButton size="medium">
                                <CheckIcon />
                            </IconButton>
                        </Tooltip>
                    </div>

                    {this.state.isOpen && <div className="kanban-report-block">
                        <div className="clearfix">
                            {this.state.selectedReport === 0 && <>
                                <div className="kanban-report-item">
                                    <ProjectDistributionReport />
                                </div>
                            </>
                            }
                            {this.state.selectedReport === 1 && <>
                                <div className="kanban-report-item">
                                    <WorkPressureReport />
                                </div>
                                <div className="kanban-report-item">
                                    <EffectivityReport />
                                </div>
                            </>
                            }
                            {this.state.selectedReport === 2 && <>
                                <div className="kanban-report-item">
                                    Здесь что-то будет
                                </div>
                            </>
                            }
                            {this.state.selectedReport === 4 && <>
                                <div className="kanban-report-item">
                                    <AllProjectsCosts />
                                </div>
                            </>
                            }
                        </div>
                        <BottomNavigation
                            value={this.state.selectedReport}
                            onChange={(event, newValue) => {
                                this.setState({ selectedReport: newValue });
                            }}
                            showLabels
                        >
                            <BottomNavigationAction label="Проекты" className="kanban-bottom-report-navigation" />
                            <BottomNavigationAction label="Люди" className="kanban-bottom-report-navigation" />
                            <BottomNavigationAction label="Я" className="kanban-bottom-report-navigation" />
                        </BottomNavigation>
                    </div>}

                </div>
            </Collapse>
        );
    }
});

export default FilterBottomPanel;